module.exports = __webpack_public_path__ + "static/media/completed.887024f7.jpg";